import { PATH_NAMES } from '../constants';
import { piercingServicePagePath } from '../helpers';

export const config = {
  firstPagePath: `${piercingServicePagePath}`,
  piercingAppointmentTypesNextPath: PATH_NAMES.SELECT_SHOP,
  shopsPrevPath: `${piercingServicePagePath}`,
  shopsNextPath: '/select-date',
  selectDatePrevPath: '/shops',
  aboutYouPrevPath: '/select-date',
  reviewPrevPath: '/about-you',

  editShopNextPath: 'edit-date',
  editDatePrevPath: 'edit-shop',
};
